// extracted by mini-css-extract-plugin
module.exports = {"modal":"TimeoutModal-modal-7618","root":"TimeoutModal-root-7618","clock":"TimeoutModal-clock-7618"};